class AudioManager {
  private context?: AudioContext;
  private muted = false;

  unlock(): void {
    if (!this.context) this.context = new AudioContext();
    if (this.context.state === 'suspended') void this.context.resume();
  }

  setMuted(muted: boolean): void { this.muted = muted; }

  play(kind: 'click' | 'goal' | 'jump' | 'kick' | 'skill' | 'countdown' | 'win'): void {
    if (this.muted || !this.context || this.context.state !== 'running') return;
    const now = this.context.currentTime;
    const oscillator = this.context.createOscillator();
    const gain = this.context.createGain();
    const notes: Record<typeof kind, [number, number, number]> = {
      click: [520, 0.035, 0.025], goal: [245, 0.42, 0.13], jump: [360, 0.08, 0.035],
      kick: [150, 0.075, 0.04], skill: [740, 0.18, 0.045], countdown: [440, 0.11, 0.05], win: [620, 0.5, 0.1],
    };
    const [frequency, duration, volume] = notes[kind];
    oscillator.type = kind === 'goal' ? 'triangle' : 'sine';
    oscillator.frequency.setValueAtTime(frequency, now);
    oscillator.frequency.exponentialRampToValueAtTime(Math.max(70, frequency * (kind === 'goal' ? 1.8 : 0.72)), now + duration);
    gain.gain.setValueAtTime(volume, now);
    gain.gain.exponentialRampToValueAtTime(0.001, now + duration);
    oscillator.connect(gain).connect(this.context.destination);
    oscillator.start(now);
    oscillator.stop(now + duration);
  }
}

export const audio = new AudioManager();
